import { useEffect, useState } from "react";

/**
 * A value that lags behind by `delay` while it keeps changing.
 *
 * For values a query is keyed on that a person types: the intermediate states
 * of "15" are "1" and then "15", and asking the server about "1" is both a
 * wasted round trip and an answer that flashes on screen before the real one.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
